// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAKRkiEsZkZHHKzBM2fTzuwDGKLg2VFV58",
  authDomain: "tbwc-c944e.firebaseapp.com",
  projectId: "tbwc-c944e",
  storageBucket: "tbwc-c944e.firebasestorage.app",
  messagingSenderId: "292023875231",
  appId: "1:292023875231:web:c46e0f2e0cd31561da54aa",
  measurementId: "G-ENRC1WLNB9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
